import { Button, Table, Badge } from "react-bootstrap";
import { useState, useEffect } from "react";
import { useAuth } from "../../providers/authprovider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSpinner,
  faCheckCircle,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import useAlert from "../../components/CustomAlert";
import { ControlledMenu, MenuItem, useMenuState } from "@szhsin/react-menu";
import { useDataProvider } from "../../providers/offline_data_provider";
import { getProtocolTypeLabel } from "./protocolTypes";

const isDevelopment = process.env.NODE_ENV === "development";

export default function ProtocolsTable(props) {
  const { showAlert, hideAlert, alert } = useAlert();
  const { protocols, onEdit, onDelete } = props;
  const {protocols : {listCachedProtocolIds, cacheProtocol}}  = useDataProvider();
  const {
    user,
    protocols: { download, remove, getProtocolById },
    viewPdf,
  } = useAuth();
  const [downloadingId, setDownloadingId] = useState([]);
  const [anchorPoint, setAnchorPoint] = useState({ x: 0, y: 0 });
  const [contextProtocol, setContextProtocol] = useState(undefined);
  const [menuProps, toggleMenu] = useMenuState();
  const [cachedProtocols, setCachedProtocols] = useState({});

  useEffect(() => {
    const checkCache = async () => {
      const result = {};
      const cachedIds = await listCachedProtocolIds();
      for (const prot of protocols || []) {
        const isCached = cachedIds.includes(prot.id);
        result[prot.id] = isCached;
      }
      setCachedProtocols(result);
    };

    if (protocols?.length) {
      checkCache();
    }
  }, [protocols]);

  const handleDownloadPdf = (event, id) => {
    event.stopPropagation();

    setDownloadingId((prevState) => {
      return [...prevState, id];
    });

    download(id, (response) => {
      if (response.success) viewPdf(response.content);
      else showAlert(response.error);

      removeDownloadingId(id);
    });
  };

  const removeDownloadingId = (id) => {
    setDownloadingId((prevState) => {
      let index = prevState.indexOf(id);

      if (index > -1) prevState.splice(index, 1);

      return [...prevState];
    });
  };

  const isDownloading = (id) => {
    return downloadingId.includes(id);
  };

  const handleDeleteProtocol = (event, protocol) => {
    event.stopPropagation();

    if (!window.confirm("Potwierdź usunięcie protokołu. ")) return;

    hideAlert();

    remove(protocol.id, ({ success, error, content }) => {
      if (!success) return showAlert(error);

      onDelete(content);
    });
  };

  const handleCopyProtocol = () => {
    if (contextProtocol) onEdit(contextProtocol.id, true);
  };

  const handleEditProtocol = () => {
    if (contextProtocol) onEdit(contextProtocol.id);
  };

  const handleOpenContextMenu = (event, protocol) => {
    setContextProtocol(protocol);
    setAnchorPoint({ x: event.pageX, y: event.pageY });
    toggleMenu(true);
  };

  const getProtocolNamePL = (protocol) => {
    const { type, arrival_purpose } = protocol;
    if (arrival_purpose) return arrival_purpose;

    return getProtocolTypeLabel(type);
  };

  const handleDownloadProtocolData = (event, protocolId) => {
    event.stopPropagation();

    hideAlert();
    //setLoading(true);
    getProtocolById(protocolId, ({ success, error, content }) => {
      if (success === false) {
        showAlert(error);
        //setLoading(false);
        return;
      }
      if (!success) return;

      cacheProtocol(protocolId, content)

      const cached = {...cachedProtocols, [protocolId]: true}
     
      setCachedProtocols(cached);

      //setLoading(false);
    });
  };

  return (
    <div>
      {alert()}
      <ControlledMenu
        {...menuProps}
        anchorPoint={anchorPoint}
        align={"start"}
        onMouseLeave={() => toggleMenu(false)}
        onClose={() => toggleMenu(false)}
      >
        <MenuItem onClick={handleEditProtocol}>Edytuj</MenuItem>
        <MenuItem onClick={handleCopyProtocol}>Kopiuj</MenuItem>
      </ControlledMenu>
      <Table bordered hover size={"sm"}>
        <thead>
          <tr>
            <th>#</th>
            <th>Obiekt</th>
            <th>Cel przyjazdu</th>
            <th>Wykonał</th>
            <th>Data protokołu</th>
            {isDevelopment && <th>Typ</th>}
            {isDevelopment && <th>Wersja</th>}
            <th>Podgląd</th>
            <th>Pobrany</th>
            {user.isAdmin && <th>Usuń</th>}
          </tr>
        </thead>
        <tbody>
          {protocols?.map((prot, index) => (
            <tr
              key={prot.id}
              className={"cursor-pointer"}
              onClick={(e) => handleOpenContextMenu(e, prot)}
            >
              <td>{index + 1}</td>
              <td>{prot.building?.building_name}</td>
              <td>{getProtocolNamePL(prot)}</td>
              <td>{prot.userName}</td>
              <td>{new Date(prot.date).toLocaleDateString()}</td>
              {isDevelopment && <td>{prot.type}</td>}
              {isDevelopment && <td>{prot.version}</td>}
              <td>
                {isDownloading(prot.id) ? (
                  <Button variant={"outline-secondary"}>
                    <FontAwesomeIcon icon={faSpinner} spin={true} />
                  </Button>
                ) : (
                  <Button
                    variant={"outline-secondary"}
                    onClick={(e) => handleDownloadPdf(e, prot.id)}
                  >
                    {" "}
                    PDF
                  </Button>
                )}
              </td>
              <td>
                {/* display icon if its cached */}
                {cachedProtocols[prot.id] ? (
                  <Badge pill bg={"success"}>
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      className="me-2"
                      title="pobrany"
                    />
                    <span>pobrany</span>
                  </Badge>
                ) : (
                  <Button
                    variant={"outline-secondary"}
                    onClick={(e) => handleDownloadProtocolData(e, prot.id)}
                  >
                    <FontAwesomeIcon
                      icon={faDownload}
                      className="me-2"
                      style={{ color: "gray" }}
                      title="download"
                    />
                    Pobierz
                  </Button>
                )}
              </td>
              {user.isAdmin && (
                <td>
                  <Button
                    variant={"outline-secondary"}
                    onClick={(e) => {
                      handleDeleteProtocol(e, prot);
                    }}
                    className={"btn-close"}
                  ></Button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
